import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Checkbox, Form, Input, InputNumber, message, Popconfirm, Row, Select, Space, AutoComplete } from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';

import dayjs from 'dayjs';
import ajax from '@/scripts/ajax';
import axios from 'axios';
import _ from 'lodash';
import { Log } from '@icon-park/react';
// 重量随机：20.5 ~ 21.5
const getRandomWeight = () => Math.floor(Math.random() * 1001) + 20500;

const defaultValue = {
    // cargo_details: 'Fabrics, textiles',
    send_num: 1,
    // import_service_mode: 'CY',
    account_name: '-1',
    commodity_key: '-1',
    box_type: '40',
    destination_service_mode: 'CY',
    container_quantity: 1,
    is_usa: false,
    weight: getRandomWeight(),
};
export default function HplBookOrderListForm(props) {
    const { id, cache, onValueChange } = props;
    const [form] = Form.useForm();
    const [accountTags, setAccountTags] = useState(['-1']);
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [usaBookAccounts, setUsaBookAccounts] = useState([]);
    const [usaAccountsLoading, setUsaAccountsLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [accountOptions, setAccountOptions] = useState([]);
    const [accountLoading, setAccountLoading] = useState(false);
    const [formDefaultValue, setFormDefaultValue] = useState(null);
    const [commodityOptions, setCommodityOptions] = useState([]);
    const [commodityLoading, setCommodityLoading] = useState(false);
    useEffect(() => {
        let finalValue = { ...defaultValue };
        if (cache) {
            const cacheCopy = { ...cache };

            finalValue = { ...finalValue, ...cacheCopy };
        }
        const w = Number(finalValue.weight);
        if (!Number.isFinite(w) || w < 20500 || w > 21500) {
            finalValue.weight = getRandomWeight();
        }
        setFormDefaultValue(finalValue);
    }, [cache]);
    useEffect(() => {
        // 获取账号列表
        setAccountLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/accounts')
            .then((res) => {
                const options = res.data.map((item) => ({ label: item, value: item }));
                // 在最前面增加 -1 选项
                setAccountOptions([{ label: '-1', value: '-1' }, ...options]);
            })
            .catch((err) => {
                console.error('获取账号列表失败', err);
                message.error('获取账号列表失败');
            })
            .finally(() => setAccountLoading(false));
    }, []);
    useEffect(() => {
        // 获取美线订舱账号列表（用于 is_usa 勾选时随机取号）
        setUsaAccountsLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/accounts/book')
            .then((res) => {
                setUsaBookAccounts(Array.isArray(res.data) ? res.data : []);
            })
            .catch((err) => {
                console.error('获取美线账号列表失败', err);
                message.error('获取美线账号列表失败');
            })
            .finally(() => setUsaAccountsLoading(false));
    }, []);
    useEffect(() => {
        // 获取品名列表
        setCommodityLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/commodities')
            .then((res) => {
                const items = Array.isArray(res.data?.items) ? res.data.items : [];
                const options = items.map((item) => ({
                    label: `${item.cargo_description} - ${item.hs_code}`,
                    value: `${item.cargo_description}||${item.hs_code}`,
                }));
                setCommodityOptions([{ label: '-1', value: '-1' }, ...options]);
            })
            .catch((err) => {
                console.error('获取品名列表失败', err);
                message.error('获取品名列表失败');
            })
            .finally(() => setCommodityLoading(false));
    }, []);
    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                setSubmitting(true);

                const {
                    start_port_en_name,
                    end_port_en_name,
                    box_type,
                    destination_service_mode,
                    account_name,
                    container_quantity,
                    weight,
                    is_usa,
                    commodity_key,
                    send_num,
                    ...rest
                } = formValue;

                const isUsa = !!is_usa;

                let finalAccount;
                if (isUsa) {
                    // 勾选 is_usa：从接口拉到的美线账号里随机取一个
                    if (usaBookAccounts.length === 0) {
                        message.error('美线账号列表为空，请稍后重试');
                        setSubmitting(false); // 关键：提前 return 前必须复位 loading
                        return;
                    }
                    const randomIdx = Math.floor(Math.random() * usaBookAccounts.length);
                    finalAccount = usaBookAccounts[randomIdx];
                } else {
                    // 不勾选：走原逻辑
                    finalAccount = account_name;
                    if (account_name === '-1') {
                        if (accountOptions.length > 0) {
                            const randomIndex = Math.floor(Math.random() * accountOptions.length);
                            finalAccount = accountOptions[randomIndex].value;
                        } else {
                            message.warning('账号列表为空，无法随机选择，请手动输入');
                            setSubmitting(false);
                            return;
                        }
                    }
                }
                const task_info = {
                    start_port_en_name,
                    end_port_en_name,
                    box_type,
                    destination_service_mode,
                    account_name: finalAccount,
                    container_quantity,
                    weight,
                };

                if (commodity_key === '-1') {
                    // 选 -1：从品名里随机取一个（排除 -1 本身）
                    const realOptions = commodityOptions.filter((opt) => opt.value !== '-1');
                    if (realOptions.length === 0) {
                        message.error('品名列表为空，无法随机选择');
                        setSubmitting(false);
                        return;
                    }
                    const randomIdx = Math.floor(Math.random() * realOptions.length);
                    const [cargo_description, hs_code] = realOptions[randomIdx].value.split('||');
                    task_info.cargo_description = cargo_description;
                    task_info.hs_code = hs_code;
                } else if (commodity_key) {
                    // 选具体品名
                    const [cargo_description, hs_code] = commodity_key.split('||');
                    task_info.cargo_description = cargo_description;
                    task_info.hs_code = hs_code;
                }

                const sendNum = Math.max(1, Number(formValue.send_num) || 1);

                const baseValue = {
                    task_type: 'hpl',
                    ignore_is_run: true,
                    send_num: 1,
                    ...rest,
                };

                const hasUserWeight = formValue.weight !== undefined && formValue.weight !== null && formValue.weight !== '';
                const isWeightManuallyChanged = hasUserWeight && Number(formValue.weight) !== Number(formDefaultValue.weight);

                // send_num 是几就调用几次接口
                const requests = Array.from({ length: sendNum }, () => {
                    const singleTaskInfo = {
                        ...task_info,
                        // 用户手动输入：每次请求都用用户输入的同一个重量
                        // 未手动修改：每次请求都重新随机
                        weight: isWeightManuallyChanged ? formValue.weight : getRandomWeight(),
                    };
                    return axios.post('http://183.249.91.105:15600/query/submit', {
                        ...baseValue,
                        task_info: singleTaskInfo,
                    });
                });

                Promise.allSettled(requests)
                    .then((results) => {
                        const okCount = results.filter((r) => r.status === 'fulfilled').length;
                        const failCount = results.length - okCount;
                        if (failCount === 0) {
                            message.success(`订舱提交成功 ${okCount} 次`);
                        } else {
                            message.warning(`提交完成：成功 ${okCount} 次，失败 ${failCount} 次`);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleReset = () => {
        form.resetFields();
        form.setFieldsValue({ ...formDefaultValue, is_usa: false, commodity_key: '-1' });
        onValueChange(id, { ...formDefaultValue, is_usa: false, commodity_key: '-1' });
        setAccountTags(['-1']);
    };

    const handleDelete = () => {
        onValueChange(id, 'delete');
    };

    const handleValueChange = async () => {
        const formValue = await form.getFieldsValue();
        onValueChange(id, formValue);
    };

    if (!formDefaultValue) return null;

    return (
        <Form form={form} initialValues={formDefaultValue} onValuesChange={handleValueChange}>
            <Card style={{ minWidth: 1150 }}>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="启始港" name="start_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港" name="end_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={6}>
                        <Form.Item label="日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col> */}
                    <Col span={6}>
                        {/* <Form.Item label="账号" name="account_name">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item> */}
                        <Form.Item label="账号" name="account_name" style={{ marginBottom: 0 }}>
                            <Select
                                onChange={setAccountTags}
                                // style={{ width: '100%' }}
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ minWidth: 200 }}
                                options={accountOptions}
                                loading={accountLoading}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="美线" name="is_usa" valuePropName="checked">
                            <Checkbox></Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱型" name="box_type">
                            <Select options={createJsonOptions(['20', '40', '45'])} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱量" name="container_quantity">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="send_num" name="send_num">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="重量（Kg）" name="weight">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="品名" name="commodity_key">
                            <Select
                                options={commodityOptions}
                                showSearch
                                allowClear
                                loading={commodityLoading}
                                optionFilterProp="label"
                                placeholder="请选择品名"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港服务模式" name="destination_service_mode">
                            <Select options={createJsonOptions(['CY', 'SD'])} showSearch></Select>
                        </Form.Item>
                    </Col>
                </Row>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Space>
                        <Popconfirm title="确认" description="是否执行该操作?" onConfirm={handleDelete} okText="是" cancelText="否">
                            <Button danger ghost>
                                删除
                            </Button>
                        </Popconfirm>
                        <Button onClick={handleReset}>重置</Button>
                    </Space>

                    <Button onClick={handleSubmit} type="primary" loading={submitting}>
                        开始订舱
                    </Button>
                </div>
            </Card>
        </Form>
    );
}
